import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ca } from '@cian/analytics';
import { Button, ButtonSize, ButtonTheme } from '@cian/button-component';
import { Popup } from '@cian/popup-component';

import { CloseIcon } from '../../../../components/close_icon';

const style = require('./location_tooltip.css');

interface ILocationSwitcherProps extends React.Props<Location> {
  displayName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onAccept(): any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDecline(): any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose(): any;
}

export class LocationTooltip extends React.Component<ILocationSwitcherProps> {
  private container: HTMLElement | null = document.getElementById('header_last_container');

  public componentDidMount() {
    ca('event', {
      name: 'oldevent',
      category: 'GEO_block',
      action: 'view',
    });
  }

  public render() {
    if (!this.container) {
      return null;
    }

    return ReactDOM.createPortal(
      <div className={style['container']}>
        <Popup containerStyle={style['tooltip-container']}>
          <CloseIcon onClick={this.handleClose} className={style['close']} />
          <div className={style['tooltip-content']}>
            <div className={style['tooltip-text']}>Ваш регион - {this.props.displayName}</div>
            <div className={style['tooltip-buttons']}>
              <Button className={style['tooltip-button']} size={ButtonSize.S} onClick={this.handleAccept}>
                Да
              </Button>
              <Button
                className={style['tooltip-button']}
                size={ButtonSize.S}
                theme={ButtonTheme.Ghost}
                onClick={this.handleDecline}
              >
                Выбрать другой
              </Button>
            </div>
          </div>
        </Popup>
      </div>,
      this.container,
    );
  }

  private handleAccept = (): void => {
    this.props.onAccept();

    ca('event', {
      name: 'oldevent',
      category: 'GEO_block',
      action: 'click_yes',
      label: this.props.displayName,
    });
  };

  private handleDecline = (): void => {
    this.props.onDecline();

    ca('event', {
      name: 'oldevent',
      category: 'GEO_block',
      action: 'click_no',
    });
  };

  private handleClose = () => {
    this.props.onClose();
  };
}
